import _ from 'lodash';
import moment from 'moment';
import { MOMENT_TIME_FORMAT } from '../constants/date_format';

// Sentry context helpers - IDs, days and times only, no names, labels or notes.
// To reproduce: reload with the same termSchoolID + week + objectTypeID/objectID, then find the entry by id.

const time = (value) => (moment.isMoment(value) ? value.format(MOMENT_TIME_FORMAT) : value);

export const timetableEntryIds = (entry) =>
    entry && {
        id: entry.id,
        timetableID: entry.timetableID,
        classID: entry.classID,
        objectTypeID: entry.objectTypeID,
        objectID: entry.objectID,
        dayOfWeek: entry.dayOfWeek,
        timeIn: time(entry.timeIn),
        timeOut: time(entry.timeOut),
        instructorIDs: entry.instructors?.map((i) => i.instructorID),
        setIDs: entry.sets?.map((s) => s.setID),
        roomID: entry.room?.roomID,
    };

export const timetableContainerIds = (container) =>
    container && {
        objectTypeID: container.objectTypeID,
        objectID: container.objectID,
        timetableIDs: container.timetable?.timetables?.map((t) => t.id),
        conflictIDs: container.timetable?.conflicts?.map((t) => t.id),
    };

// label holds the instructor or room display name
export const battleshipMoveIds = (moves) => moves?.map((move) => _.omit(move, 'label'));
